import script from "./LabelInput.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelInput.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__